export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redefinir"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar tudo"])}
}